"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SegmentSchema = void 0;
const zod_1 = require("zod");
const LineStyle_1 = require("./LineStyle");
const DrawingBase_1 = require("./DrawingBase");
const XYPosition_1 = require("./XYPosition");
exports.SegmentSchema = DrawingBase_1.DrawingBaseSchema.extend({
    type: zod_1.z.literal('segment'),
    start: XYPosition_1.XYPositionSchema,
    end: XYPosition_1.XYPositionSchema,
    width: zod_1.z.number(),
    style: LineStyle_1.LineStyleSchema.optional(),
    curve: zod_1.z.number().optional(),
});
//# sourceMappingURL=Segment.js.map